module.exports = __webpack_public_path__ + "img/pCardUs.7da6b80f.png";